<template>
  <div>
    <div class="container">
      <h3>Prospect</h3>
      <template v-if="prospect_data_loading && initial_start === 1">
        <h5>Loading</h5>
      </template>
      <template v-else>
        <table>
            <tr>
              <td class="field_style_address">
                Company<br>
                <input
                    class="input_long"
                    type="text"
                    id="company"
                    v-model="prospect_data.account.company"
                    placeholder=""
                    name="company"
                    @input="prospect_data.account.company = $event.target.value"
                    @blur="set_prospect_field('company',prospect_data.account.company)"
                />
              </td>
              <td class="field_style_address">
                Address<br>
                <input
                    class="input_long"
                    type="text"
                    id="address"
                    v-model="prospect_data.account.address"
                    placeholder=""
                    name="address"
                    @input="prospect_data.account.address = $event.target.value"
                    @blur="set_prospect_field('address',prospect_data.account.address)"
                />
              </td>
              <td class="field_style_address">
                City<br>
                <input
                    class="input_medium"
                    type="text"
                    id="city"
                    v-model="prospect_data.account.city"
                    placeholder=""
                    name="city"
                    @input="prospect_data.account.city = $event.target.value"
                    @blur="set_prospect_field('city',prospect_data.account.city)"
                />
              </td>
              <td class="field_style_address">
                Zipcode<br>
                <input
                    class="input_short"
                    type="text"
                    id="zipcode"
                    v-model="prospect_data.account.zipcode"
                    placeholder=""
                    name="zipcode"
                    @input="prospect_data.account.zipcode = $event.target.value"
                    @blur="set_prospect_field('zipcode',prospect_data.account.zipcode)"
                />
              </td>
            </tr>

          </table>

           <table>

            <tr>
            <td class="field_style_address">
              Contact Person<br>
              <input
                  class="input_mediumg"
                  type="text"
                  id="contactperson"
                  v-model="prospect_data.account.contactperson"
                  placeholder=""
                  name="contactperson"
                  @input="prospect_data.account.contactperson = $event.target.value"
                  @blur="set_prospect_field('contactperson',prospect_data.account.contactperson)"
              />
            </td>
            <td class="field_style_address">
              Progress Status<br>
              <input
                  type="text"
                  id="progress"
                  v-model="prospect_data.account.progress"
                  placeholder=""
                  name="progress"
                  @input="prospect_data.account.progress = $event.target.value"
                  @blur="set_prospect_field('progress',prospect_data.account.progress)"
              />
            </td>
            <td class="field_style_address">
              Email<br>
              <input
                  type="text"
                  id="email"
                  v-model="prospect_data.account.email"
                  placeholder=""
                  name="email"
                  @input="prospect_data.account.email = $event.target.value"
                  @blur="set_prospect_field('email',prospect_data.account.email)"
              />
            </td>
            <td class="field_style_address">
              Phone#<br>
              <input
                  type="text"
                  id="phone"
                  v-model="prospect_data.account.phone"
                  placeholder=""
                  name="phone"
                  @input="prospect_data.account.phone = $event.target.value"
                  @blur="set_prospect_field('phone',prospect_data.account.phone)"
              />
            </td>
            </tr>
          </table>

          <div class="add_note_block">
            <input type="text" id="note" class="note_input" v-model="new_note">
            <button class="add_note_button" @click="store_prospect_note_in_database()">Add Note</button>
          </div>

          <br>
          <table v-if="prospect_data.notes" class="table table-striped table-bordered">
            <thead>
            </thead>
            <tbody>
            <tr v-for="notes in prospect_data.notes" v-bind:key="notes.id">
              <td width="200">{{ notes.dateformatted }}</td>
              <td align="LEFT">{{ notes.notetext }}</td>
            </tr>
            </tbody>
          </table>
          <br>
          <br>

      </template>
      </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      new_note: '',
      initial_start: 0,
    }
  },
  computed: {
    ...mapGetters({
      prospect_data: 'admin/prospect_data',
      prospect_data_loading: 'admin/prospect_data_loading',
    }),
  },
  mounted() {
    this.get_prospect_data();
  },
  watch:  {
    prospect_data: async function () {
      this.initial_start = 0;
    },
  },
  props: {
    prospectid : null,
  },
  methods: {
    store_prospect_note_in_database() {
      this.$store.dispatch('admin/setProspectField', {fieldname:'new_note',value:this.new_note,'prospectid':this.prospectid})
      this.new_note = '';
    },
    get_prospect_data () {
      this.initial_start = 1;
      this.$store.dispatch('admin/setProspectField', {fieldname:'prospect_start',value:'all_data','prospectid':this.prospectid})
    },
    set_prospect_field(fieldname,value) {
      this.$store.dispatch('admin/setProspectField', {fieldname,value,'prospectid':this.prospectid})
    },
  }
}
</script>

<style scoped>


.field_style_address {
  color: black;
  font-size: 16px;
  text-align: left;
  padding-left: 0px;
  padding-right: 17px;
  padding-bottom: 15px;
}

.input_long {
  padding: 3px;
  padding-left: 7px;
  width:350px;
  font-size: 20px;
  color: blue;
}

.input_medium {
  padding: 3px;
  padding-left: 7px;
  width:260px;
  font-size: 20px;
  color: blue;
}

.input_short {
  padding: 3px;
  padding-left: 7px;
  width:80px;
  font-size: 20px;
  color: blue;
}


input {
  padding: 3px;
  padding-left: 7px;
  width:260px;
  font-size: 20px;
  color: blue;
}

.add_note_block {
  text-align: left;
}

.add_note_button {
  color: white;
  background-color: green;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 3px;
  border-radius: 4px;
  border-style: hidden;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  margin-left: 15px;
  margin-right: 10px;
}

.note_input {
  padding: 3px;
  padding-left: 7px;
  width: 815px;
  font-size: 20px;
  color: blue;
}



.location_select select {
  padding: 2px 7px;
  margin-bottom: 10px;
  margin-top: 5px;
  color: black;
  font-size: 18px;
  font-weight: 500;
}

</style>
